import SimpleTable from "@/components/SimpleTable";
import { handleCompanyName } from "@/lib/handleName";
import { AssessmentProgress } from "@/schema/AssessmentProgress";
import ActionButton from "@/src/console/(auth)/(check-assessments)/re-assessments/_components/ActionButton";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
interface ReAssessmentTableProps {
  data: AssessmentProgress[];
  isLoading: boolean;
}

function ReAssessmentTable({ data, isLoading }: ReAssessmentTableProps) {
  const { t } = useTranslation();
  return (
    <SimpleTable
      isLoading={isLoading}
      data={data}
      columns={[
        {
          key: "companyName",
          label: t("company-name"),
          render: ({ id, company_name }) => handleCompanyName(id, company_name),
        },
        {
          key: "assessmentDate",
          label: t("assessment-date"),
          render: ({ start_date, end_date }) => (
            <div>
              <div>
                {t("start-date")} : {start_date ? format(start_date, t("date-format")) : "---"}
              </div>
              <div>
                {end_date? format(end_date, t("date-format")) : "---"}
              </div>
            </div>
          ),
        },
        {
          width: "170px",
          key: "submittedAt",
          label: t("submitted-at"),
          render: ({ submitted_at }) => {
            const date = submitted_at
              ? format(submitted_at, t("date-format"))
              : "----/--/-";
            const time = submitted_at
              ? format(submitted_at, t("time-format"))
              : "--:--";
            return (
              <div>
                <div className="font-medium text-cool-gray-600">{date}</div>
                <div className="text-cool-gray-600">{time}</div>
              </div>
            );
          },
        },
        {
          key: "status",
          label: t("status"),
          render: ({ status: { name } }) => name,
        },
        {
          key: "action",
          label: t("action"),
          render: ({ id, status }) => (
            <ActionButton id={id} status={status.id} />
          ),
        },
      ]}
    />
  );
}

export default ReAssessmentTable;
